import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  getBatchAcademicCalendar,
  getSubjectsUnderBatchId,
  getSingleDayAttendance,
  deleteBatchAttendance,
} from '../../../../redux/features/batchSlice';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Box, Button, Grid, Paper, Stack, TextField } from '@mui/material';
import Loader3D from '../../../../components/Loader/Loader3D';
import BatchDetailsChip from './BatchDetailsChip';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import CalendarBoxDesign from './CalendarBoxDesign';
import CustomGridToolbar from '../../../../components/datagrid/GridToolBar';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { DataGrid } from '@mui/x-data-grid';
import { academicCalendarTableHeader } from '../../../../components/datagrid/academicCalendar/academicCalendarTableHeader';
import { getRescheduledCalendars } from '../../../../redux/features/CRDslice';
import useResponsive from '../../../../Hooks/useResponsive';
import SingleDayAttendanceCards from './SingleDayAttendanceCards';
import { batchCalendarTableHead } from '../../../../components/datagrid/CRD/batchCalendar/batchCalendarTableHead';
import GlobalDeleteDialog from '../../../../components/mui/Dialogue/GlobalDeleteDialog';

// const batchDetails = {
//   batchName: 'Batch A',
//   batchId: 'B123',
//   syllabus: 'Syllabus A',
//   capacity: 30,
// };

// const calendarDataOld = [
//   {
//     session_no: 1,
//     type: 'Class',
//     id: 1,
//     session_schedule_id: 16376,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-02',
//     week_day: 3,
//     from_time: '09:00:00',
//     to_time: '10:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 1109859,
//     academic_calendar_id: 56,
//     academic_calendar_data: {
//       session_no: 6,
//       chapter: 'malayalam',
//       topic: 'basic',
//       objectives: 'writing',
//     },
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 2,
//     id: 2,
//     session_schedule_id: 16395,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-03',
//     week_day: 4,
//     from_time: '09:00:00',
//     to_time: '10:00:00',
//     rescheduled_id: 16377,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 3,
//     type: 'Class',
//     id: 3,
//     session_schedule_id: 16379,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-08',
//     week_day: 2,
//     from_time: '11:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 1109861,
//     academic_calendar_id: 58,
//     academic_calendar_data: {
//       session_no: 2,
//       chapter: 'terst',
//       topic: 'test topic',
//       objectives: 'topic',
//     },
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 4,
//     type: 'Class',
//     id: 4,
//     session_schedule_id: 16524,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-09',
//     week_day: 3,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: 16380,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 10,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 5,
//     type: 'Class',
//     id: 5,
//     session_schedule_id: 16498,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-09',
//     week_day: 3,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 12345,
//     academic_calendar_id: 57,
//     academic_calendar_data: {
//       session_no: 7,
//       chapter: 'english',
//       topic: 'intermediate',
//       objectives: 'speaking',
//     },
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 6,
//     type: 'Class',
//     id: 6,
//     session_schedule_id: 16497,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-09',
//     week_day: 3,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 12345,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 7,
//     type: 'Class',
//     id: 7,
//     session_schedule_id: 16496,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-09',
//     week_day: 3,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 12345,
//     academic_calendar_id: 59,
//     academic_calendar_data: {
//       session_no: 4,
//       chapter: 'test',
//       topic: 'jklj',
//       objectives: 'fd',
//     },
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 8,
//     type: 'Class',
//     id: 8,
//     session_schedule_id: 16499,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-15',
//     week_day: 2,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: 16383,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 12345,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     session_no: 9,
//     id: 9,
//     session_schedule_id: 16512,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-16',
//     week_day: 3,
//     from_time: '09:00:00',
//     to_time: '10:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: 1,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 10,
//     id: 10,
//     session_schedule_id: 16514,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-16',
//     week_day: 3,
//     from_time: '13:00:00',
//     to_time: '14:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 11,
//     id: 11,
//     session_schedule_id: 16513,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-16',
//     week_day: 3,
//     from_time: '15:00:00',
//     to_time: '16:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 12,
//     id: 12,
//     session_schedule_id: 16515,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-22',
//     week_day: 2,
//     from_time: '11:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 13,
//     id: 13,
//     session_schedule_id: 16516,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-23',
//     week_day: 3,
//     from_time: '09:00:00',
//     to_time: '10:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 14,
//     id: 14,
//     session_schedule_id: 16518,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-23',
//     week_day: 3,
//     from_time: '13:00:00',
//     to_time: '14:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 15,
//     id: 15,
//     session_schedule_id: 16517,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-23',
//     week_day: 3,
//     from_time: '15:00:00',
//     to_time: '16:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 16,
//     id: 16,
//     session_schedule_id: 16519,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-29',
//     week_day: 2,
//     from_time: '11:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 17,
//     id: 17,
//     session_schedule_id: 16520,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-30',
//     week_day: 3,
//     from_time: '09:00:00',
//     to_time: '10:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 18,
//     id: 18,
//     session_schedule_id: 16522,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-30',
//     week_day: 3,
//     from_time: '13:00:00',
//     to_time: '14:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 19,
//     id: 19,
//     session_schedule_id: 16521,
//     subject_enrollment_id: 43248,
//     session_date: '2025-07-30',
//     week_day: 3,
//     from_time: '15:00:00',
//     to_time: '16:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: 1,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
//   {
//     session_no: 20,
//     id: 20,
//     session_schedule_id: 16523,
//     subject_enrollment_id: 43248,
//     session_date: '2025-08-05',
//     week_day: 2,
//     from_time: '11:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     academic_calendar_data: null,
//     trainer_attendance_data: null,
//   },
// ];

// const calendarData = [
//   {
//     id: 1,
//     session_no: 1,
//     type: 'Class',
//     session_schedule_id: 16983,
//     subject_enrollment_id: 43290,
//     session_date: '2025-08-01',
//     week_day: 5,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: 4,
//     academic_calendar_id: 1,
//     subject_name: 'English',
//     academic_calendar_data: {
//       session_no: 1,
//       chapter: 'Basic',
//       topic: 'Basic ',
//       objectives: 'Learn',
//     },
//     trainer_attendance_data: {
//       attendance_type: 1,
//       attendanceTypeDetails: {
//         attendance_type_name: 'Class',
//         attendance_type_id: 1,
//       },
//     },
//   },
//   {
//     id: 2,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16988,
//     subject_enrollment_id: 43291,
//     session_date: '2025-08-02',
//     week_day: 6,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Biology',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 3,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16984,
//     subject_enrollment_id: 43290,
//     session_date: '2025-08-04',
//     week_day: 1,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'English',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 4,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16989,
//     subject_enrollment_id: 43291,
//     session_date: '2025-08-04',
//     week_day: 1,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Biology',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 5,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16979,
//     subject_enrollment_id: 43289,
//     session_date: '2025-08-05',
//     week_day: 2,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Arabic',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 6,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16985,
//     subject_enrollment_id: 43290,
//     session_date: '2025-08-05',
//     week_day: 2,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'English',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 7,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16980,
//     subject_enrollment_id: 43289,
//     session_date: '2025-08-06',
//     week_day: 3,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Arabic',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 8,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16986,
//     subject_enrollment_id: 43290,
//     session_date: '2025-08-06',
//     week_day: 3,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'English',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 9,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16981,
//     subject_enrollment_id: 43289,
//     session_date: '2025-08-07',
//     week_day: 4,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Arabic',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 10,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16987,
//     subject_enrollment_id: 43290,
//     session_date: '2025-08-07',
//     week_day: 4,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'English',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 11,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16982,
//     subject_enrollment_id: 43289,
//     session_date: '2025-08-08',
//     week_day: 5,
//     from_time: '10:00:00',
//     to_time: '11:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Arabic',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 12,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16990,
//     subject_enrollment_id: 43291,
//     session_date: '2025-08-09',
//     week_day: 6,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Biology',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 13,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16991,
//     subject_enrollment_id: 43291,
//     session_date: '2025-08-11',
//     week_day: 1,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Biology',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 14,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16992,
//     subject_enrollment_id: 43291,
//     session_date: '2025-08-16',
//     week_day: 6,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: null,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 1,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Biology',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
//   {
//     id: 15,
//     session_no: null,
//     type: null,
//     session_schedule_id: 16993,
//     subject_enrollment_id: 43291,
//     session_date: '2025-08-17',
//     week_day: 1,
//     from_time: '10:00:00',
//     to_time: '12:00:00',
//     rescheduled_id: 16978,
//     rescheduled_at: null,
//     rescheduled_reason: null,
//     scheduled_status: 1,
//     scheduled_id: 2,
//     reschedule_requested_by: null,
//     trainerAttendanceID: null,
//     academic_calendar_id: null,
//     subject_name: 'Biology',
//     academic_calendar_data: {
//       session_no: null,
//       chapter: null,
//       topic: null,
//       objectives: null,
//     },
//     trainer_attendance_data: {
//       attendance_type: null,
//       attendanceTypeDetails: {
//         attendance_type_name: null,
//         attendance_type_id: null,
//       },
//     },
//   },
// ];

// const details = {
//   total: 100,
//   present: 60,
//   absent: 40,
// };

const attendance = [{ serialNumber: 1, name: 'subhin', admnNo: 12345, attendance: 'Present' }];

const BatchCalendarLanding = () => {
  const lgDown = useResponsive('down', 'lg');
  const { rescheduledCalendars, loading: crdLoading } = useSelector((state) => state.crd);
  const [open, setOpen] = useState(false);
  const [singleDayAttendanceModalOpen, setSingleDayAttendanceModalOpen] = useState(false);
  const [gridSize, setGridSize] = useState(10);
  const location = useLocation();
  const batchDetails = location.state?.batchDetails || {};
  const queryParams = new URLSearchParams(location.search);
  const batchId = queryParams.get('BatchID');
  const dispatch = useDispatch();
  const [selectedSubjectId, setSelectedSubjectId] = useState(0);
  const {
    loading,
    subjects: Subjects,
    calendarData,
    singleDayAttendance,
    modalLoading,
  } = useSelector((state) => state.batch);
  const dispatchParams = {
    batchId: batchId || null,
    subjectId: selectedSubjectId || null,
  };
  const subjects = [{ subject_enrollment_id: 0, subject_name: 'All' }, ...Subjects];
  const [attendanceDetails, setAttendanceDetails] = useState({});
  useEffect(() => {
    if (batchId) {
      dispatch(getSubjectsUnderBatchId(batchId));
    }
  }, [batchId]);

  useEffect(() => {
    dispatch(getBatchAcademicCalendar(dispatchParams));
  }, [batchId, selectedSubjectId]);

  const handleChange = (name, value) => {
    if (name === 'subjectId') {
      setSelectedSubjectId(value);
    }
  };
  const boxClickFunction = useCallback((item) => {
    //CALLBACK FUNCTION TO OPEN DIALOG BOX IT ONLY OPEN THE DIALOG BOX IF THE SESSION IS RESCHEDULED AND IT WILL CALL API FOR TO LOG RESCHEDULED SESSIONS DETAILAS
    if (item.rescheduled_id) {
      setOpen(true);
      dispatch(getRescheduledCalendars(item.session_schedule_id));
    }
  }, []);

  const singleDayAttendancViewFuction = useCallback((item) => {
    setSingleDayAttendanceModalOpen(true);
    setAttendanceDetails({ ...item, batchId: batchId });
    dispatch(getSingleDayAttendance(item?.trainerAttendanceID));
  }, []);
  return (
    <GlobalWrapper title={'Batch Academic Calendar'}>
      <Box>
        {loading ? (
          <Box>
            <Loader3D />
          </Box>
        ) : (
          <Box>
            <Stack spacing={1} direction={lgDown ? 'column' : 'row'}>
              <Box flex={1}>
                <Autocomplete
                  name={'subjectId'}
                  fullWidth
                  options={subjects}
                  getOptionLabel={(option) =>
                    `${option.subject_name} ${option?.total_sessions ? `- ${option.total_sessions} Sessions ` : ''}`
                  }
                  value={subjects.find((data) => data.subject_enrollment_id == selectedSubjectId) || null}
                  onChange={(e, option) => handleChange('subjectId', option?.subject_enrollment_id)}
                  renderInput={(params) => <TextField fullWidth autoComplete="off" {...params} label="Subjects" />}
                />
              </Box>
              {/* <Box flex={2}>
                <BatchDetailsChip batchDetails={batchDetails} />
              </Box> */}
            </Stack>
            <Box mt={1}>
              <BatchDetailsChip batchDetails={batchDetails} />
            </Box>
            <Box mt={2}>
              {calendarData.length == 0 ? (
                <Box mt={10}>
                  <NoDataFound />
                </Box>
              ) : (
                <>
                  <Paper elevation={3} sx={{ p: 2, borderRadius: 1 }}>
                    <Grid container spacing={2}>
                      {calendarData.length &&
                        calendarData.map((item) => (
                          <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                            <CalendarBoxDesign
                              boxClickFunction={boxClickFunction}
                              item={item}
                              singleDayAttendancViewFuction={singleDayAttendancViewFuction}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </Paper>

                  {open && (
                    <GlobalDialog
                      open={open}
                      setOpen={setOpen}
                      maxWidth={'lg'}
                      fullWidth
                      title={'Rescheduled Details'}
                      closeButton={true}
                      closeCondition={() => setOpen(false)}
                      content={
                        crdLoading ? (
                          <Loader3D />
                        ) : (
                          <Box>
                            <DataGrid
                              components={{ Toolbar: CustomGridToolbar }}
                              rows={rescheduledCalendars}
                              columns={academicCalendarTableHeader}
                              loading={loading}
                              getRowId={(row) => row.session_schedule_id}
                              pageSize={gridSize}
                              autoHeight
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
                            />
                          </Box>
                        )
                      }
                    />
                  )}

                  {singleDayAttendanceModalOpen && (
                    <GlobalDialog
                      open={singleDayAttendanceModalOpen}
                      setOpen={setSingleDayAttendanceModalOpen}
                      maxWidth={'lg'}
                      fullWidth
                      title={'Single Day Attendance'}
                      closeButton={true}
                      closeCondition={() => setSingleDayAttendanceModalOpen(false)}
                      content={
                        modalLoading ? (
                          <Loader3D />
                        ) : (
                          <Box>
                            <SingleDayAttendanceCards data={singleDayAttendance?.details} />
                            <Box mb={1}>
                              <GlobalDeleteDialog
                                disabled={false}
                                title={'Delete Attendance'}
                                buttonName={'Delete Attendance'}
                                deleteNote={'Are you sure? you want to delete this Attendance..?'}
                                api={deleteBatchAttendance({
                                  session_schedule_id: attendanceDetails?.session_schedule_id,
                                  batchId: batchId,
                                })}
                                upDateCall={getBatchAcademicCalendar(dispatchParams)}
                                otherActions={() => {
                                  setSingleDayAttendanceModalOpen(false);
                                  setAttendanceDetails({});
                                }}
                                loading={loading}
                              />
                            </Box>
                            <DataGrid
                              components={{ Toolbar: CustomGridToolbar }}
                              rows={singleDayAttendance?.attendance}
                              columns={batchCalendarTableHead}
                              loading={loading}
                              getRowId={(row) => row.serialNumber}
                              pageSize={gridSize}
                              autoHeight
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
                            />
                          </Box>
                        )
                      }
                    />
                  )}
                </>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default BatchCalendarLanding;
